import { Switch, Redirect, Route, useRouteMatch } from 'peach/router'

import Document from './Document'
import Documents from './Documents'

const DocumentRoutes = () => {
  const { path, url } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={path}>
        <Documents />
      </Route>
      <Route crumb path={`${path}/:documentId`}>
        <Document />
      </Route>
      <Redirect to={url} />
    </Switch>
  )
}

export default DocumentRoutes
